import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import login from "../Assets/party8.jpg";
import { API_URI } from "../Common/data";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Signup() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    password: "",
    mobile: "",
    otp: "",
  });
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, name, password, mobile } = formData;

    if (!email || !name || !password || !mobile) {
      toast.error("All fields are required!");
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API_URI}/user/create`, formData);
      setLoading(false);
      setOtpSent(true);
      toast.success("OTP sent to your mobile number!");
      setTimer(30);
      setCanResend(false);
    } catch (error) {
      setLoading(false);
      const errorMsg =
        error.response?.data?.message || "Something went wrong, try again!";
      toast.error(errorMsg);
    }
  };

  const handleOtpSubmit = async () => {
    const { mobile, otp } = formData;
    try {
      setLoading(true);
      const response = await axios.post(`${API_URI}/user/create/verify`, {
        mobile,
        otp,
      });
      if (response.status === 200) {
        const data = response?.data?.data;
        localStorage.setItem("cine_user", JSON.stringify(data?.user));
        localStorage.setItem("cine_userToken", data?.tokens?.accessToken);
        setLoading(false);
        toast.success("User registered successfully!");
        setFormData({
          email: "",
          name: "",
          password: "",
          mobile: "",
          otp: "",
        });
        navigate("/");
      }
    } catch (error) {
      setLoading(false);
      const errorMsg = error.response?.data?.message || "Invalid OTP, try again!";
      toast.error(errorMsg);
    }
  };

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      await axios.post(`${API_URI}/user/create`, formData);
      setLoading(false);
      toast.success("OTP resent to your mobile number!");
      setTimer(30);
      setCanResend(false);
    } catch (error) {
      setLoading(false);
      toast.error("Failed to resend OTP");
    }
  };

  useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  useEffect(() => {
    document.body.classList.add("auth-page-active");

    return () => {
      document.body.classList.remove("auth-page-active");
    };
  }, []);

  return (
    <>
      <Navbar />
      <section className="auth-shell auth-shell--signup">
        <div className="auth-shell__inner">
          <div className="auth-panel">
            <div className="auth-panel__copy">
              <p className="auth-panel__eyebrow">Create Account</p>
              <h1>Join Cine Celebrate and start planning with less friction.</h1>
              <p className="auth-panel__text">
                Save your details, verify your mobile number once, and make it
                easier to manage bookings, add-ons, and support requests later.
              </p>
            </div>

            <div className="auth-card">
              <div className="auth-card__header">
                <p className="auth-panel__eyebrow">Sign Up</p>
                <h3>{otpSent ? "Verify your OTP" : "Set up your account"}</h3>
                <p>
                  {otpSent
                    ? "Enter the OTP sent to your mobile number to activate your account."
                    : "Fill in your details and we will send an OTP to confirm your mobile number."}
                </p>
              </div>

              <div className="auth-form">
                {!otpSent ? (
                  <>
                    <label>Full Name</label>
                    <input
                      name="name"
                      type="text"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleChange}
                    />

                    <label>Email Address</label>
                    <input
                      name="email"
                      type="email"
                      placeholder="Enter your email address"
                      value={formData.email}
                      onChange={handleChange}
                    />

                    <label>Mobile Number</label>
                    <input
                      name="mobile"
                      type="text"
                      placeholder="Enter mobile number"
                      value={formData.mobile}
                      onChange={handleChange}
                    />

                    <label>Password</label>
                    <input
                      name="password"
                      type="password"
                      placeholder="Create a password"
                      value={formData.password}
                      onChange={handleChange}
                    />

                    <button type="button" disabled={loading} onClick={handleSubmit}>
                      {loading ? <Loader /> : "Send OTP"}
                    </button>
                  </>
                ) : (
                  <>
                    <label>OTP</label>
                    <input
                      name="otp"
                      type="text"
                      placeholder="Enter OTP"
                      value={formData.otp}
                      onChange={handleChange}
                    />

                    <button
                      type="button"
                      disabled={loading}
                      onClick={handleOtpSubmit}
                    >
                      {loading ? <Loader /> : "Verify OTP"}
                    </button>

                    <div className="auth-inline-meta">
                      {!canResend ? (
                        <p>Resend OTP in {timer}s</p>
                      ) : (
                        <button
                          type="button"
                          className="auth-text-button"
                          onClick={handleResendOtp}
                          disabled={loading}
                        >
                          {loading ? "Resending..." : "Resend OTP"}
                        </button>
                      )}
                    </div>
                  </>
                )}

                <div className="auth-inline-meta auth-inline-meta--spread">
                  <button
                    type="button"
                    className="auth-text-button"
                    onClick={() => navigate("/login")}
                  >
                    Already have an account?
                  </button>
                </div>
              </div>
            </div>
          </div>

          <aside className="auth-visual auth-visual--signup">
            <div className="auth-visual__frame">
              <img src={login} alt="Signup" />
            </div>
            <div className="auth-visual__note">
              <span>New account</span>
              <strong>One profile for bookings, updates, and celebration support</strong>
            </div>
          </aside>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Signup;
